module.exports = __webpack_public_path__ + "media/images/flags/TC-a579e740be36c5ea97c2108bde9cef7a.svg";